import { css, fillOutlined, circle } from './draw-utils';
import type { ProceduralDef } from '../types';

const GLASS = 0xbfd0e8; // pale spectral mirror
const SHEEN = 0xeaf2ff;

/**
 * B12 Mirror — a spectral echo of the player ship. A reflective
 * diamond hull with a split seam down the middle; it copies the player's
 * delayed movements and throws shots back. docs/02 boss pool.
 */
export const bossMirrorBody: ProceduralDef = {
  key: 'boss/mirror/body',
  width: 130,
  height: 130,
  anchorX: 0.5,
  anchorY: 0.5,
  frames: 1,
  draw(ctx, w, h) {
    const c = w / 2;

    // Cold spectral halo
    const halo = ctx.createRadialGradient(c, c, 16, c, c, c);
    halo.addColorStop(0, 'rgba(191,208,232,0.4)');
    halo.addColorStop(1, 'rgba(191,208,232,0)');
    circle(ctx, c, c, c);
    ctx.fillStyle = halo;
    ctx.fill();

    // Diamond hull
    const r = 48;
    ctx.beginPath();
    ctx.moveTo(c, c - r);
    ctx.lineTo(c + r * 0.7, c);
    ctx.lineTo(c, c + r);
    ctx.lineTo(c - r * 0.7, c);
    ctx.closePath();
    fillOutlined(ctx, GLASS, 5);

    // Mirror seam + reflected highlight (one half brighter)
    ctx.beginPath();
    ctx.moveTo(c, c - r);
    ctx.lineTo(c + r * 0.7, c);
    ctx.lineTo(c, c + r);
    ctx.closePath();
    ctx.fillStyle = css(SHEEN);
    ctx.globalAlpha = 0.45;
    ctx.fill();
    ctx.globalAlpha = 1;

    // Seam line
    ctx.strokeStyle = css(0x8fa6c8);
    ctx.lineWidth = 2.5;
    ctx.beginPath();
    ctx.moveTo(c, c - r);
    ctx.lineTo(c, c + r);
    ctx.stroke();

    // Core eye
    circle(ctx, c, c, 9);
    ctx.fillStyle = css(SHEEN);
    ctx.fill();
    void h;
  },
};
